import { defineStore } from "pinia";

export const useFingerStore = defineStore('fingerprint', {
	state: () => ({
		fingerprintHash: null, 
	}),
	getters: {
		getFingerprintHash: (state) => state.fingerprintHash,
	},
	actions: {
		setFingerprintHash(hash) {
			this.fingerprintHash = hash;
		},
		clearFingerprintHash() {
			this.fingerprintHash = null; 
		}
	}
});
